<template lang="html">
	<wizard-screen :completed="3" :total="5">
		<div class="omapi-onboarding__tabs">
			<button
				class="omapi-onboarding__tabs-button"
				:class="{ active: activeTab === 'included' }"
				@click="setTab('included')"
			>
				Included Features
			</button>
			<button
				class="omapi-onboarding__tabs-button"
				:class="{ active: activeTab === 'free' }"
				@click="setTab('free')"
			>
				Free Add-Ons
			</button>
		</div>
		<div v-if="activeTab === 'included'">
			<div class="omapi-onboarding__features-section">
				<p>Every OptinMonster subscription includes the following features at no additional cost:</p>
				<div class="omapi-feature-group">
					<wizard-feature v-for="feature in includedFeatures" :key="feature.slug" :feature="feature" />
				</div>
			</div>
			<div class="omapi-onboarding__features-section">
				<h4>Recommended Features</h4>
				<p>Based on your goals, we also recommend the following features:</p>
				<div class="omapi-feature-group">
					<wizard-feature v-for="feature in recommendedFeatures" :key="feature.slug" :feature="feature" />
				</div>
			</div>
		</div>
		<div v-if="activeTab === 'free'">
			<div class="omapi-onboarding__features-section">
				<p>
					We recommend enhancing your site with these free WordPress plugins.<br />No commitment required -
					you can remove them at any time.
				</p>
				<div class="omapi-feature-group">
					<wizard-select-all />
					<div id="all-plugins-wrap">
						<wizard-feature v-for="feature in addOnFeatures" :key="feature.slug" :feature="feature" />
					</div>
				</div>
			</div>
		</div>
		<template #after-card>
			<div v-if="activeTab === 'free'" class="omapi-text-center">
				<small v-if="pluginsList" class="omapi-will-be-installed">
					The following plugins will be installed for free:
					{{ pluginsList }}
				</small>
			</div>
			<wizard-exit />
		</template>
	</wizard-screen>
</template>

<script lang="js">
import { featureMap } from '@/wizard/data'
import { mapGetters } from 'vuex'

export default {
	data () {
		return {
			activeTab: 'included',
			addOnSlugs: ['wpforms','google-analytics', 'seo', 'social-proof', 'landing-pages'],
			featureMap,
			includedFeatureSlugs: ['campaigns', 'page-level-targeting'],
			recommendedFeatureSlugs: ['split-test', 'exit-intent', 'yesno', 'content-locker', 'onsite-targeting'],
		}
	},
	computed : {
		...mapGetters('wizard', [ 'inExtraFeatures' ]),
		...mapGetters([ 'onboardingUsage' ]),
		/**
		 * List of plugins that will be installed.
		 *
		 * @returns {string} The compiled list of plugins.
		 */
		pluginsList () {
			const list = this.featureMap.filter(f => {
				return f.plugin && this.inExtraFeatures(f.slug)
			}).map(f => {
				return f.plugin.title
			})

			return list.length ? list.join(', ') : ''
		},
		/**
		 * List of features that are included with every subscription.
		 *
		 * @returns {Array} The list of features.
		 */
		includedFeatures() {
			return this.featureMap.filter(f => {
				return this.includedFeatureSlugs.includes(f.slug)
			})
		},
		/**
		 * List of features that are recommended.
		 *
		 * @returns {Array} The list of features.
		 */
		recommendedFeatures() {
			return this.featureMap.filter(f => {
				return this.recommendedFeatureSlugs.includes(f.slug)
			})
		},
		/**
		 * List of features that are free add-ons/plugins.
		 *
		 * @returns {Array} The list of features.
		 */
		addOnFeatures() {
			return this.featureMap.filter(f => {
				return this.addOnSlugs.includes(f.slug)
			})
		},
	},
	methods: {
		/**
		 * Set the active tab.
		 *
		 * @param {string} tab The tab to set as active.
		 *
		 * @returns {void}
		 */
		setTab (tab) {
			this.activeTab = tab
		},
	},
};
</script>
